import Icon from '../components/Icon.vue'

Icon.register({
  'graduation-cap': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M622.3 153.2c23.5 7.2 23.5 38.4 0 45.6l-278.9 85.7c-20.3 6.3-37.7 2.8-46.8 0l-195.6-60.1c-12.3 8.4-19.9 21.7-20.7 36.7 9.2 5.6 15.7 15.3 15.7 26.9 0 10.8-5.7 19.8-13.9 25.7l25.5 114.9c2.2 10-5.4 19.5-15.6 19.5h-56.1c-10.2 0-17.8-9.5-15.6-19.5l25.5-114.9c-8.2-5.8-13.9-14.9-13.9-25.7 0-11.9 6.8-21.8 16.4-27.4 0.6-17.6 7.2-33.7 17.9-46.9l-48.6-14.9c-23.5-7.2-23.5-38.4 0-45.6l278.9-85.7c15.2-4.7 31.6-4.7 46.8 0zM352.8 315.1l145-44.6 14.2 113.5c0 35.3-86 64-192 64s-192-28.7-192-64l14.2-113.5 145 44.5c12.8 3.9 37.1 8.8 65.6 0z'
      }
    ]
  }
})
